import { getRotatedRectangleGeometry } from '@/utils/rotatedRectangle';
import { PRESENTATION_CONSTANTS } from './constants';
/**
 * Вычисляет базовый масштаб для центрирования элемента на экране
 */
export const calculateBaseScale = (bounds, screenSize) => Math.min(screenSize.width / bounds.w, screenSize.height / bounds.h);
/**
 * Вычисляет масштаб и смещения для центрирования элемента
 */
export const calculatePresentationTransform = (bounds, screenSize) => {
    const scale = calculateBaseScale(bounds, screenSize);
    // Вычисляем размеры элемента после масштабирования
    const scaledWidth = bounds.w * scale;
    const scaledHeight = bounds.h * scale;
    // Центрируем элемент на экране
    const offsetX = (screenSize.width - scaledWidth) / 2 - bounds.x * scale;
    const offsetY = (screenSize.height - scaledHeight) / 2 - bounds.y * scale;
    return {
        scaleX: scale,
        scaleY: scale,
        offsetX,
        offsetY,
    };
};
/**
 * Проверяет, изменился ли вид презентации
 */
export const hasViewChanged = (oldZoom, newZoom, oldPosition, newPosition) => {
    const { ZOOM_CHANGE_THRESHOLD, POSITION_CHANGE_THRESHOLD } = PRESENTATION_CONSTANTS;
    return (Math.abs(newZoom - oldZoom) > ZOOM_CHANGE_THRESHOLD ||
        Math.abs(newPosition.x - oldPosition.x) > POSITION_CHANGE_THRESHOLD ||
        Math.abs(newPosition.y - oldPosition.y) > POSITION_CHANGE_THRESHOLD);
};
export function getElementGeometry(element) {
    var _a, _b, _c, _d, _e;
    const { DEFAULT_ELEMENT_SIZE } = PRESENTATION_CONSTANTS;
    return getRotatedRectangleGeometry({
        x: ((_a = element.props) === null || _a === void 0 ? void 0 : _a.x) || 0,
        y: ((_b = element.props) === null || _b === void 0 ? void 0 : _b.y) || 0,
        w: ((_c = element.props) === null || _c === void 0 ? void 0 : _c.w) || DEFAULT_ELEMENT_SIZE,
        h: ((_d = element.props) === null || _d === void 0 ? void 0 : _d.h) || DEFAULT_ELEMENT_SIZE,
        rotation: ((_e = element.props) === null || _e === void 0 ? void 0 : _e.rotation) || 0,
    });
}
export const getElementBounds = (element) => getElementGeometry(element).bounds;
export const sortPresentationElements = (elements) => {
    return [...elements].sort((a, b) => { var _a, _b; return ((_a = a.presentationOrder) !== null && _a !== void 0 ? _a : 0) - ((_b = b.presentationOrder) !== null && _b !== void 0 ? _b : 0); });
};
